// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tc-viewport {\n  padding-top: 125px;\n}\n.tc-viewport.tc-viewport-topbar-hidden {\n  padding-top: 0;\n}\n.tc-viewport .tc-topbar:not(.tc-home-hero-topbar) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  background-color: rgba(255,255,255,0.95);\n  z-index: 10;\n}\n.tc-viewport .tc-section {\n  margin: 100px 0;\n}\n", ""]);
// Exports
module.exports = exports;
